import lazyLoading from './lazyLoading'

export default {
  name: 'ticketsBasic',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [
    {
      name: 'clarification-ticket',
      path: '/utils/clarification-ticket',
      component: lazyLoading('tools/AssignTicket'),
      meta: {
        title: 'Aclaración de Boletos',
        requiresAuth: true
      }
    },
    {
      name: 'InvoiceList',
      path: '/invoices',
      component: lazyLoading('app/invoices/InvoiceList'),
      meta: {
        title: 'Facturas Emitidas',
        requiresAuth: true
      }
    },
    // {
    //   name: 'sales',
    //   path: '/sales',
    //   component: lazyLoading('app/sales/List'),
    //   meta: {
    //     title: 'Ventas',
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/financial/aircab-sales-company',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/Company/AircabList'),
          meta: {
            title: 'Lista Aircab'
          }
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/ticketsBasic.js